import type {ExtraInfo} from './types';

const DATA: ExtraInfo = {
  surveyUrl: 'https://forms.gle/oRi8oXF6VzPMh4Pj6',
  checkInCode: '9547',
  details: [
    {
      type: 'description',
      heading: 'Event Overview',
      paragraphs: [
        {
          content:
            "Are you starting your software engineering career in Japan, or looking to advance your skills? Becoming a great software engineer in Japan's dynamic tech scene involves more than just writing code.",
        },
        {
          content:
            "Join us for an insightful talk with Leen Sun, an Engineering Manager at Woven by Toyota. With 18 years in the tech industry, Leen has progressed from engineer to tech leader, now managing teams. She's eager to share her experience and practical advice for navigating a tech career in Japan.",
        },
        {
          content:
            'In this session, Leen will offer personal experiences and actionable insights to help you work effectively, grow with confidence, and build a strong foundation for a successful software engineering career. Anyone interested in shaping a robust tech career path is welcome! Join us to learn how to succeed in your professional journey.',
        },
      ],
    },
    {type: 'registration-form'},
    {
      type: 'list',
      heading: 'Who is this for',
      items: [
        'Students & aspiring engineers: Gain foundational career insights before starting',
        'New software engineers: Accelerate learning, build effective work habits',
        'Junior developers: Practical advice for daily challenges, skill growth',
        'Individuals seeking mentorship: Direct wisdom from an experienced industry leader',
        'Mentors & lifelong learners: Support new talent, continuous professional development',
      ],
    },
    {
      type: 'description',
      heading: 'Guest and Topic Introduction',
      paragraphs: [
        {
          heading: 'Leen Sun, Engineering Manager, Woven by Toyota',
          content:
            'Leen is an engineering manager working in the Tech industry for 18 years, previously working at Treasure Data and Rakuten.  She started her career as an engineer, then a tech leader, and now leads teams to work on cloud and AI technologies.  Looking back on her journey, she’s happy to share her experience, insights, and best practices with those just starting to work as software engineers.',
        },
        {
          heading:
            'Topic: Insights and Best Practices for New Software Engineers',
          content:
            'Becoming a software engineer isn’t just about coding. It’s also about how you think, how you learn, and how you collaborate with others. In the early stages of your career, small habits, the right mindset, and intentional choices can make a big difference. In this talk, Leen will share personal experiences and practical advice to help you work effectively, grow with confidence, and build a strong foundation for the future.',
        },
      ],
    },
    {
      type: 'schedule',
      heading: 'Timetable',
      items: [
        {
          timeUTC: 1752281100,
          description: 'Online meeting room opens & check-in',
        },
        {
          timeUTC: 1752282000,
          description: 'Opening',
        },
        {
          timeUTC: 1752282300,
          description:
            'Guest Talk: Insights and Best Practices for New Software Engineers',
          info: ['Leen Sun, Engineering Manager, Woven by Toyota'],
        },
        {
          timeUTC: 1752284100,
          description: 'Q&A',
        },
        {
          timeUTC: 1752285000,
          description: 'Closing & Feedback',
        },
        {
          timeUTC: 1752285600,
          description: 'Event end',
        },
      ],
    },
    {
      type: 'description',
      heading: 'Important Information',
      paragraphs: [
        {
          content:
            'Application: The event is free to attend. Once your registration is confirmed, you will receive a calendar invitation. Please sign up by Thursday, July 10, 2025.',
        },
        {
          content:
            "Language: The event will primarily be conducted in English. However, you're welcome to ask questions in both English and Japanese.",
        },
        {
          content:
            'Video Participation: To foster a warm and engaging atmosphere, we kindly ask all participants to keep their cameras on during the session. ',
        },
        {
          content:
            'Photography & Recording: Screenshots and recordings may be taken during the online event for promotional purposes (e.g., social media, future event materials). By registering, you consent to using these materials unless you inform us otherwise.',
        },
        {
          content:
            'Schedule: Please note that the event schedule is subject to change on the day of the event.',
        },
        {
          content:
            'Contact: For any event-related inquiries, please contact alliz via email at event@alliz.jp.',
        },
      ],
    },
    {
      type: 'description',
      heading: 'About Host',
      paragraphs: [
        {
          content:
            'alliz is a career mentorship community led by its members, dedicated to career design and development in Japan. We foster mentorship and meaningful connections through community-driven activities, bringing together students, early-career professionals, and mentors from tech-related industries. By sharing experiences, insights, and guidance, we promote mutual growth and learning.',
        },
      ],
    },
  ],
  tags: [],
  thumbnailURL:
    '/static/images/kMASOkQt47/weBBN9bXTc2K4DTNKrx80ZYojKiJA0dv.png',
};

export default DATA;
